import { createPageDataFeature } from '../../page-data/create-page-data-feature';
import { createDeleteItemFeature } from '../../delete-item/delete-item-feature';
import { CryptotokenKey } from 'src/app/shared/entities/cryptotoken-key';

export const {
  feature: cryptotokenKeyDataFeature,
  selectors: CryptotokenKeyDataSelectors,
  actions: CryptotokenKeyDataActions,
  pipes: CryptotokenKeyDataPipes,
  createEffects: createCryptotokenKeyDataEffects,
} = createPageDataFeature<
  'CryptotokenKeys Data',
  { tokenName: string },
  CryptotokenKey[]
>('CryptotokenKeys Data');

export const {
  feature: cryptotokenKeyDeleteFeature,
  actions: CryptotokenKeyDeleteActions,
  createEffects: createCryptotokenKeyDeleteEffects,
} = createDeleteItemFeature<'CryptotokenKeys Delete', CryptotokenKey>(
  'CryptotokenKeys Delete',
);

export const CryptotokenKeyDeleteSelectors = {
  cryptotokenBeingDeleted: cryptotokenKeyDeleteFeature.selectItemBeingDeleted,
  isDeleting: cryptotokenKeyDeleteFeature.selectDeleting,
};
